import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class VisualAnimation {
  constructor(el) {
    this.dom = {el: el};
    this.dom.visual = this.dom.el.querySelector('[data-js="visual-visual"]');
    this.dom.imageWrapper = this.dom.el.querySelector('[data-js="visual-image"]');
    this.dom.cover = this.dom.el.querySelector('[data-js="visual-cover"]');

    this.windowH = window.innerHeight;
    this.targetBCR = this.dom.imageWrapper.getBoundingClientRect();

    // window.addEventListener('load', () => {
    //   this.targetScale = this.targetBCR.height / this.windowH;
    //   this.targetScale = this.targetScale * 1.05;
    //   this.init();
    // })
    this.targetScale = 1.05;
    this.init();
  }

  init() {
    if (this.getWindowW() < 768) {
      gsap.to(this.dom.cover, {
        scale: this.targetScale,
        translate: '0 -5%',
        scrollTrigger: {
            trigger: '[data-js="hero"]',
            toggleActions: 'play none none reverse',
            start: 'top 0%',
            end: 'bottom bottom',
            scrub: true,
            // markers: true,
            // onUpdate: (e)=>{
            //   console.log(e.progress);
            // }
        },
        onStart: ()=>{},
        onComplete: ()=>{}
      })
    } else {
      gsap.to(this.dom.cover, {
        translate: '0 -5%',
        scrollTrigger: {
            trigger: '[data-js="hero"]',
            toggleActions: 'play none none reverse',
            start: 'top 0%',
            end: 'bottom 0%',
            scrub: true,
            // markers: true,
            // onUpdate: (e)=>{
            //   console.log(e.progress);
            // }
        },
        onStart: ()=>{},
        onComplete: ()=>{}
      })
    }
  }

  getWindowW() {
    return window.innerWidth;
  }
}

export default VisualAnimation